<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Promo</li>
        <li class="breadcrumb-item active">Records</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="caption">
          <h6>Promo records list</h6>
        </div>
        <div class="actions">
          <router-link v-if="$store.state.permissions.create.promo" :to="{ name: 'promo-create' }" class="btn btn-success">Create new record</router-link>
        </div>
      </div>
      <div class="card-body">
        <div v-if="$store.state.permissions.see.promo" class="row">
          <div class="col-xl-12">
            <table-component ref="promos" :show-filter="false" :data="fetchRows" sort-by="order_idx" sort-order="asc" table-class="table" @rowClick="rowClicked">
              <table-column show="id" label="#"/>
              <table-column show="title" label="Title"/>
              <table-column show="order_idx" label="Order"/>
              <table-column
                :sortable="false"
                :filterable="false"
                label="Actions"
              >
                <template slot-scope="row">
                  <router-link
                    v-if="$store.state.permissions.edit.promo"
                    :to="{ name: 'promo-edit', params: { testimonialId: row.id } }"
                    @click.stop="() => true"
                  >
                    <i v-tooltip.top-center="'Edit'" class="icon-im icon-im-pencil" />
                  </router-link>
                  <i
                    v-tooltip.top-center="'Up'"
                    class="icon-im icon-im-move-up"
                    @click.stop="upRecord(row.id)"
                  />
                  <i
                    v-tooltip.top-center="'Down'"
                    class="icon-im icon-im-move-down"
                    @click.stop="downRecord(row.id)"
                  />
                  <i
                    v-tooltip.top-center="'Delete'"
                    v-if="$store.state.permissions.delete.promo"
                    class="icon-im icon-im-bin delete--link"
                    @click.stop="deleteRecord(row.id)"
                  />
                </template>
              </table-column>
            </table-component>
          </div>
        </div>
        <div v-else>
          <h3>You have not permission for do that</h3>
        </div>
      </div>
    </div>
    <sweet-modal ref="delete_confirm" hide-close-button blocking title="Confirm delete">
      Confirm delete testimonial record
      <button
        slot="button"
        type="button"
        class="btn btn-primary"
        @click="cancelDelete()"
      >Cancel</button>
      <button slot="button" type="button" class="btn btn-danger" @click="deleteRecord()">Confirm</button>
    </sweet-modal>
  </div>
</template>

<script>
/* global axios, toastr */
import { SweetModal } from 'sweet-modal-vue'
export default {
  name: 'PromoList',
  components: {
    SweetModal
  },
  data () {
    return {
      recordForDelete: null
    }
  },
  methods: {
    deleteRecord (id) {
      let that = this
      if (this.recordForDelete) {
        axios
          .delete('/api/admin/promo/' + this.recordForDelete)
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              that.$refs.promos.refresh()
              that.recordForDelete = null
              toastr['success']('Record has been deleted successfully')
            } else {
              let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
              toastr['error'](message)
              that.recordForDelete = null
            }
          })
          .catch(error => {
            console.log(error)
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
        this.$refs.delete_confirm.close()
      } else {
        this.recordForDelete = id
        this.$refs.delete_confirm.open()
      }
    },
    cancelDelete () {
      this.recordForDelete = null
      this.$refs.delete_confirm.close()
    },
    rowClicked (row) {
      if (row.data && row.data.id) {
        this.$router.push('/admin/promo/' + row.data.id + '/edit')
      }
    },
    upRecord (id) {
      let that = this
      axios.post('/api/admin/promo/reorder', { record: id, to: 'up' })
        .then(response => {
          if (response && response.data && response.data.result === 'ok') {
            that.$refs.promos.refresh()
          }
        })
        .catch(error => {
          console.log(error)
          let message = (error && error.message) || 'Something goes wrong'
          toastr['error'](message)
        })
    },
    downRecord (id) {
      let that = this
      axios.post('/api/admin/promo/reorder', { record: id, to: 'down' })
        .then(response => {
          if (response && response.data && response.data.result === 'ok') {
            that.$refs.promos.refresh()
          }
        })
        .catch(error => {
          console.log(error)
          let message = (error && error.message) || 'Something goes wrong'
          toastr['error'](message)
        })
    },
    async fetchRows ({ page, filter, sort }) {
      const response = await axios.post('/api/admin/promo', {
        page: page,
        filter: filter,
        sort: sort
      })

      return {
        data: response.data.promos,
        pagination: {
          totalPages: response.data.totalPages,
          currentPage: response.data.currentPage,
          count: response.data.count
        }
      }
    }
  }
}
</script>

<style>
.delete--link:hover {
  cursor: pointer;
}
</style>
